/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "1",
    spendId: "23",
    unit: "USD/thùng",
    title: "Giá cơ sở của kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "2",
    title: "Sản lượng dầu lãi được chia theo quý trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "24",
    unit: "Thùng",
    title: "a) Quý I:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "25",
    unit: "Thùng",
    title: "b) Quý II:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "26",
    unit: "Thùng",
    title: "c) Quý III:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "27",
    unit: "Thùng",
    title: "d) Quý IV:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "3",
    title: "Giá bán dầu thô trung bình theo quý trong kỳ tính thuế",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "28",
    unit: "USD/thùng",
    title: "a) Quý I:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "29",
    unit: "USD/thùng",
    title: "b) Quý II:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "30",
    unit: "USD/thùng",
    title: "c) Quý III:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "31",
    unit: "USD/thùng",
    title: "d) Quý IV:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "4",
    spendId: "32",
    unit: "USD",
    title: "Số phụ thu phải nộp trong kỳ tính thuế: [32] = [33]+[38]+[35]+[36]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "4.1",
    spendId: "33",
    unit: "USD",
    title: "a) Quý I: [33] = 30%*{[28]-1,2*[23]}*[24]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "34",
    unit: "USD",
    title: "b) Quý II: [34]=30%*{[29]-1,2*[23]}*[25]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "35",
    unit: "USD",
    title: "c) Quý III: [35]=30%*{[30]-1,2*[23]}*[26]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "36",
    unit: "USD",
    title: "d) Quý IV: [36]=30%*{[31]-1,2*[23]}*[27]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "5",
    spendId: "37",
    unit: "USD",
    title:
      "Số phụ thu tạm tính đã kê khai tạm tính theo quý trong kỳ tính thuế: [37] = [38]+[39]+[40]+[41]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "38",
    unit: "USD",
    title: "a) Quý I:",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "39",
    unit: "USD",
    title: "Quý II: ",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "40",
    unit: "USD",
    title: "Quý III: ",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "41",
    unit: "USD",
    title: "Quý IV: ",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "",
    spendId: "41a",
    unit: "USD",
    title:
      "Chênh lệch giữa số tiền thuế phải nộp theo quyết toán với số đã kê khai trong kỳ tính thuế [41a]=[32]-[37]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "6",
    spendId: "42",
    unit: "USD",
    title: "Số phụ thu nộp thừa của kỳ tính thuế trước (nếu có)",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "7",
    spendId: "43",
    unit: "USD",
    title: "Số phụ thu nộp thiếu (hoặc thừa) trong kỳ tính thuế: [43] = [32] - [37] - [42]",
  },
  {
    id: uuidV4(),
    value4: "",
    value5: "",
    index: "8",
    spendId: "44",
    unit: "USD/VND",
    title: "Tỷ giá quy đổi",
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (spendId) =>
    ["32", "33", "34", "35", "36", "37", "41a", "43"].includes(spendId) || !spendId;

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã số
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đơn vị
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Giá trị
              </Td>
            </tr>

            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (1)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (2)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (3)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (4)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                (5)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: 800,
                  }}
                >
                  {item.spendId ? `[${item.spendId}]` : ""}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.unit}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                  }}
                >
                  {isDisabled(item.spendId) ? (
                    ""
                  ) : (
                    <InputTable
                      id={item.id}
                      value={item.value5}
                      name="value5"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
